import {IconName} from 'components';
import {ClientDevice} from 'interfaces';
import {AsyncRequestTypeName, SessionActivityName, SessionStatus} from 'interfaces/session';
import {TRANSLATION_KEYS} from 'locale';
import {ParticipantRole} from 'types';

export const PARTICIPANT_NOTIFICATION = {
    CLIENT_EVENT: 'client_event',
};

export const ACTIVITY_NAME_TRANSLATE = {
    [SessionActivityName.AudioVideo]: TRANSLATION_KEYS.FEATURES.SESSION.ACTIVITY.AUDIO_VIDEO,
    [SessionActivityName.Audio]: TRANSLATION_KEYS.FEATURES.SESSION.ACTIVITY.AUDIO,
    [SessionActivityName.CoBrowsing]: TRANSLATION_KEYS.FEATURES.SESSION.ACTIVITY.CO_BROWSING,
    [SessionActivityName.TextChat]: TRANSLATION_KEYS.FEATURES.SESSION.ACTIVITY.TEXT_CHAT,
    [SessionActivityName.SIP]: TRANSLATION_KEYS.FEATURES.SESSION.ACTIVITY.SIP,
    [SessionActivityName.ScreenSharing]: TRANSLATION_KEYS.FEATURES.SESSION.ACTIVITY.SCREEN_SHARING,
    [SessionActivityName.Avatar]: TRANSLATION_KEYS.FEATURES.SESSION.ACTIVITY.AVATAR,
    [SessionActivityName.AgentChatbot]: TRANSLATION_KEYS.FEATURES.SESSION.ACTIVITY.AGENT_CHATBOT
};

export const CLIENT_DEVICE_TRANSLATE = {
    [ClientDevice.AndroidSDK]: TRANSLATION_KEYS.COMMON.SESSION.CLIENT_DEVICE.ANDROID_SDK,
    [ClientDevice.IosSDK]: TRANSLATION_KEYS.COMMON.SESSION.CLIENT_DEVICE.IOS_SDK,
    [ClientDevice.Browser]: TRANSLATION_KEYS.COMMON.SESSION.CLIENT_DEVICE.BROWSER,
    [ClientDevice.Sip]: TRANSLATION_KEYS.COMMON.SESSION.CLIENT_DEVICE.SIP,
    [ClientDevice.Phone]: TRANSLATION_KEYS.COMMON.SESSION.CLIENT_DEVICE.PHONE
};

export const MULTI_ACTIVITIES: SessionActivityName[] = [];

export enum SystemEndSessionCode {
    AgentsUnavailable = '101',
    AfterHours = '102',
    ClientLeft = '103',
    ClientInactive = '104',
    ClientAppointmentRequest = '105',
    AppointmentNotStarted = '106',
    CompletedPreSessionFlow = '108',
    NoActiveParticipants = '201',
    NoActiveAgents = '202',
    MaxDurationExceeded = '203',
    CallingTimeout = '204',
    AppAdminEnded = '301',
    Reassigned = '401'
}

export const FEEDBACK_COMMENT_MAX_LENGTH = 500;

export const VIDEO_PIN_AUTO_HIDE_TIMEOUT = 5000;

export const ACTIVITY_ICONS: {[key in SessionActivityName]: IconName} = {
    [SessionActivityName.TextChat]: 'chat2',
    [SessionActivityName.AudioVideo]: 'audio-video',
    [SessionActivityName.CoBrowsing]: 'co-browsing',
    [SessionActivityName.ScreenSharing]: 'share-screen-out',
    [SessionActivityName.SIP]: 'sip',
    [SessionActivityName.Audio]: 'audio',
    [SessionActivityName.Avatar]: 'avatar',
    [SessionActivityName.AgentChatbot]: 'chatbot',
};

export const AGENT_CAN_ANSWER_SESSION_STATUSES = [
    SessionStatus.New,
    SessionStatus.Calling,
];

export const AGENT_ACTIVE_SESSION_STATUSES = [
    SessionStatus.InSession,
    SessionStatus.OnHold,
];

export const SESSION_ERROR_MESSAGE = {
    HAS_ACTIVE: 'Only one session per time allowed',
    SCREEN_RECORDER_REQUIRED: 'Screen recorder required',
    IN_SESSION_MINUTES_LIMIT_IS_OVER: 'In session minutes limits is over'
};

export const SCREEN_SHARING_VIDEO_TRACK = 'screen-sharing-video-track';
export const SCREEN_RECORDER_MEDIA_LABEL = 'screen-capture-recorder';

export const SCREENSHOT_CANVAS_ID = 'screenshot-canvas';
export const REMOTE_MEDIA_ID = 'remote-media';
export const LOCAL_MEDIA_ID = 'local-media';

export const USER_PARTICIPANT_ROLES = [ParticipantRole.Agent, ParticipantRole.Assistant];
export const INVITEE_PARTICIPANT_ROLES = [ParticipantRole.Client, ParticipantRole.Guest];

export const DATA_PARTICIPANT_ID = 'data-participant-id';

export const CLIENT_PROCESS_ASYNC_REQUESTS = [AsyncRequestTypeName.SumaDocumentVerificationSDK];
